import { ScrollArea } from "@circleco/compass/components/ScrollArea";
import { useLayoutEffect, useRef } from "react";

import { CircleAIBuildSection } from "./CircleAIBuildSection";
import { CircleAIDockNavSection } from "./CircleAIDockNavSection";
import { CircleAIDockRecentChatsSection } from "./CircleAIDockRecentChatsSection";
import { useBuildNavItems } from "./useBuildNavItems";
import { usePrimaryNavSectionWithBadge } from "./useDockNavSections";

const SCROLL_AREA_STYLE = {
  "--scroll-area-fade-color": "var(--color-background-secondary)",
} as React.CSSProperties;

export const CircleAIDockNavExpanded = () => {
  const primarySection = usePrimaryNavSectionWithBadge();
  const buildItems = useBuildNavItems();
  const viewportRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    viewportRef.current
      ?.querySelector("[data-dock-active]")
      ?.scrollIntoView({ block: "nearest" });
  }, []);

  return (
    <ScrollArea.Root
      scrollFades
      style={SCROLL_AREA_STYLE}
      className="relative h-full min-h-0"
    >
      <ScrollArea.Viewport ref={viewportRef} className="size-full">
        <div className="pt-1.5">
          <CircleAIDockNavSection section={primarySection} />
          <CircleAIDockRecentChatsSection />
          <CircleAIBuildSection items={buildItems} />
        </div>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar orientation="vertical" />
    </ScrollArea.Root>
  );
};
